import { api } from '@/axios/instance/api';
import type { CreateOfferPayload, Integration, Offer, OfferStats } from '@/offers/types/offer';
import {
  type AtsCandidate,
  type CreateCandidatePayload,
  type FetchCandidateJobNameParams,
  type SearchCandidatesParams,
} from '@/types';

export const apiCreateCandidate = (payload: CreateCandidatePayload) => api.post<AtsCandidate>(`candidates`, payload);

export const apiCreateLinkToken = () => api.post<{ link_token: string }>(`merge/create_link_token`);

export const apiCreateOffer = (payload: CreateOfferPayload) => api.post<Offer>(`offers`, payload);

export const getOfferStats = () => api.get<OfferStats>('offers/offer-stats');

export const apiRetrieveAccountToken = (params: { public_token: string }) =>
  api.get<{ account_token: string }>(`merge/retrieve_account_token`, { params });

export const apiFetchIntegrations = () => api.get<Integration[]>(`merge`);

export const apiFetchCandidateJobName = (params: FetchCandidateJobNameParams) =>
  api.get<string>(`merge/get_candidate_job`, { params });

export const apiSearchCandidates = (params: SearchCandidatesParams) =>
  api.get<AtsCandidate[]>(`merge/search_candidates`, { params });

export const fetchCandidates = (params: { email: string }) => api.get<AtsCandidate[]>(`candidates`, { params });
